// Scripts that will be used globally on the front.
import Klaro from '../vendor/Klaro';

// Common global scripts
require('./common');

// Vendor
Klaro.init();

global.jQuery = window.$ = window.jQuery = require('jquery');
const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

$('.nav-button').click(() => {
    $('.header-nav').toggleClass('open');
    $('.nav-button').toggleClass('open');
});

const unfoldNavContent = ($btn) => {
    if (viewportWidth < 992) {
        $('.unfold').removeClass('unfold');
        $btn.addClass('unfold');
        $btn.next('.nav-content').addClass('unfold');
    }
};

const closeNavbar = () => {
    $('.header-nav').removeClass('open');
    $('.nav-button').removeClass('open');
    $('.ajax.active').removeClass('active');
};

$('a.ajax, button.ajax').click(function () {
    if (! $(this).hasClass('brand') && ! $(this).hasClass('subcategory')) {
        if ($(this).is('a')) {
            closeNavbar();
            $(this).addClass('active');
        } else {
            unfoldNavContent($(this));
        }
    } else if( $(this).hasClass('brand')) {
        closeNavbar();
        $(this).parent().parent().parent().prev().addClass('active');
    } else if( $(this).hasClass('subcategory')) {
        closeNavbar();
        $(this).parent().parent().prev().addClass('active');
    }
});

document.querySelectorAll('.rolling-hover').forEach(link => {
    link.innerHTML = '<div><span>' + link.textContent.trim().split('').join('</span><span>') + '</span></div>';
    link.querySelectorAll('span').forEach(s => s.innerHTML = s.textContent === ' ' ? '&nbsp;' : s.textContent);
});

if (typeof dataLayer !== 'undefined') {
    // eslint-disable-next-line no-undef
    dataLayer.push({
        event: 'VirtualPageView',
        virtualPageURL: location.pathname + location.search + location.hash,
        virtualPageTitle: document.title
    });
}

